import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "../../layouts/Layout";
import { LocaleLink } from "../../i18n/LocaleLink";

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <section className="error-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="error-content">
                <h1 className="error-404">
                  4<span>0</span>4
                </h1>

                <h2 className="title">{t("error.title")}</h2>

                <p>{t("error.message")}</p>

                <LocaleLink to="/" className="btn btn-three">
                  {t("error.cta")}
                </LocaleLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ErrorPage;
